import { useContext, useMemo } from 'react';
import MantineTable from '../../../../../../common/table/mantine';
import { AppLoader } from '../../../../../../components/common/loader';
import { Footer } from '../../../../../../components/layouts/rfs/Content';
import { Button } from '@mantine/core';
import moment from 'moment';
import { CostingRequestsContext } from '../../../../../../contexts/CostingRequest';

const PIRSetupTable = ({ handleSubmit, data, status, loading, setLogsModal, fetchLogs }) => {
  const { isCrRoleAuthorized, info } = useContext(CostingRequestsContext);
  const { producing_plant_data } = info;
  const isDisabled =
    !isCrRoleAuthorized(producing_plant_data[0].producing_country) || status !== 'In Progress';

  const columns = useMemo(
    () => [
      {
        accessorKey: 'country',
        header: 'Country',
        size: 150,
      },
      {
        accessorKey: 'brewer_code',
        header: 'Brewer Code',
        size: 150,
      },
      {
        accessorKey: 'buyer_code',
        header: 'Buyer Code',
        size: 150,
      },
      {
        accessorKey: 'sku',
        header: 'SKU #',
        size: 150,
      },
      {
        accessorKey: 'currency',
        header: 'Currency TP',
        size: 150,
      },
      {
        accessorKey: 'interco_markup_out_perf',
        header: 'Re Mark up Intra grp',
        size: 180,
      },
      {
        accessorKey: 'interco_markup_out_perf_in_cognos',
        header: 'Interco Markup (in Cognos)',
        size: 220,
      },
      {
        accessorKey: 'total_tp',
        header: 'Transfer Price',
        size: 160,
      },
      {
        accessorKey: 'created_at',
        header: 'Date Updated',
        size: 150,
      },
    ],
    [loading, isDisabled],
  );

  const rightSideBtns = [
    {
      button: (
        <Button
          color='dark'
          onClick={async () => {
            try {
              const logs = await fetchLogs();
              setLogsModal({
                open: true,
                logs: logs,
                type: 'PIR Setup Logs',
              });
            } catch (error) {
              console.error('Error fetching logs:', error);
            }
          }}
        >
          View Logs
        </Button>
      ),
    },
  ];

  return (
    <>
      <div style={{ marginBottom: '80px' }}>
        <MantineTable
          columns={columns}
          initialData={data}
          unique='id'
          enableRowSelection={false}
          loading={loading}
          showSelectedToggle={false}
          hideSelectColumn={true}
          showResetAll={false}
          enableExport={true}
          rightButtons={rightSideBtns}
          csvFilename={`pir_setup_${moment().format('YYYY-MM-DD')}`}
          pageSize={10}
        />
      </div>

      <Footer>
        <Button
          onClick={handleSubmit}
          variant='gradient'
          radius='md'
          size='md'
          style={{ width: 200, float: 'right' }}
          disabled={isDisabled || loading}
        >
          {loading ? <AppLoader size='sm' /> : 'Update'}
        </Button>
      </Footer>
    </>
  );
};

export default PIRSetupTable;
